import React from 'react'
import PropTypes from 'prop-types'

const ExplainPanel = ({ explanation, mostRecentScore, scoreExplanations }) => {
  if (!explanation) return null

  const html = mostRecentScore && scoreExplanations[mostRecentScore.id]
  if (!html) return null

  return (
    <div className='explain-panel'>
      <div className='explain-panel__content'>
        {/* Score explanation HTML is generated by our internal HandicapServer, not user input */}
        <span dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </div>
  )
}

ExplainPanel.propTypes = {
  explanation: PropTypes.object,
  mostRecentScore: PropTypes.object,
  scoreExplanations: PropTypes.object,
}

export default ExplainPanel
